import { GlassPanel } from '../ui/GlassPanel';

const INFO_ITEMS = [
  { label: 'Location',     value: 'Italy' },
  { label: 'Status',       value: 'Available', highlight: true },
  { label: 'Focus',        value: 'IT & Data' },
  { label: 'Approach',     value: 'Open · Ecological · DYT' },
];

/**
 * InfoCard — contextual personal info (location, availability, focus).
 */
export function InfoCard() {
  return (
    <GlassPanel
      as="aside"
      aria-label="Personal information"
      className="flex flex-col gap-4 p-5 lg:p-6 h-full"
    >
      <h2 className="text-xs font-semibold tracking-widest uppercase text-[var(--color-muted)]">
        Info
      </h2>

      <dl className="flex flex-col gap-3 mt-1">
        {INFO_ITEMS.map(({ label, value, highlight }) => (
          <div key={label} className="flex flex-col gap-0.5">
            <dt className="text-[10px] font-medium tracking-widest uppercase text-[var(--color-muted)]/60">
              {label}
            </dt>
            <dd
              className={
                highlight
                  ? 'text-sm font-medium text-[var(--color-accent)]'
                  : 'text-sm text-[var(--color-text)]'
              }
            >
              {highlight && (
                <span
                  aria-hidden="true"
                  className="inline-block w-1.5 h-1.5 rounded-full bg-[var(--color-accent)] mr-1.5 mb-0.5 animate-pulse"
                />
              )}
              {value}
            </dd>
          </div>
        ))}
      </dl>
    </GlassPanel>
  );
}
